<template>
  <q-dialog
    v-model="show"
    persistent
    :maximized="$q.screen.lt.sm"
    transition-show="scale"
    transition-hide="scale"
  >
    <q-card class="status-epi-modal" style="min-width: 600px; max-width: 900px">
      <q-card-section class="row items-center q-pb-none bg-red-1">
        <div class="text-h6 text-red-8 text-weight-bold">
          <q-icon name="warning" color="red" size="md" class="q-mr-sm" />
          Validação de EPIs
        </div>
        <q-space />
        <q-btn
          icon="close"
          flat
          round
          dense
          v-close-popup
          :disable="isBlocked"
          color="red"
        />
      </q-card-section>

      <q-card-section class="q-pa-md">
        <div class="text-body1 text-weight-medium q-mb-md text-grey-8">
          {{ message }}
        </div>

        <div v-if="epiItems && epiItems.length > 0" class="q-mt-md">
          <div class="text-subtitle1 text-weight-bold q-mb-sm text-red-8">
            EPIs com Status "Atrasado" ({{ epiItems.length }}
            {{ epiItems.length === 1 ? "item" : "itens" }}):
          </div>

          <q-table
            :rows="paginatedItems"
            :columns="columns"
            dense
            flat
            bordered
            hide-bottom
            class="status-troca-table"
          >
            <template v-slot:header="props">
              <q-tr :props="props" class="bg-red-2">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  class="text-weight-bold text-red-9"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>

            <template v-slot:body-cell-grupo="props">
              <q-td :props="props">
                {{ props.row.grupo?.nome || props.row.grupo_nome || "N/A" }}
              </q-td>
            </template>

            <template v-slot:body-cell-critico="props">
              <q-td :props="props" class="text-center">
                <q-chip
                  v-if="props.row.critico"
                  color="red"
                  text-color="white"
                  size="sm"
                  dense
                  class="text-weight-bold"
                >
                  <q-icon name="warning" size="xs" class="q-mr-xs" />
                  CRÍTICO
                </q-chip>
                <q-chip
                  v-else
                  color="red"
                  text-color="white"
                  size="sm"
                  dense
                  class="text-weight-bold"
                >
                  NORMAL
                </q-chip>
              </q-td>
            </template>

            <template v-slot:body-cell-status="props">
              <q-td :props="props" class="text-center">
                <q-chip
                  color="red"
                  text-color="white"
                  size="sm"
                  dense
                  class="text-weight-bold"
                >
                  <q-icon name="schedule" size="xs" class="q-mr-xs" />
                  ATRASADO
                </q-chip>
              </q-td>
            </template>

            <template v-slot:body-cell-dataVencimento="props">
              <q-td :props="props" class="text-center text-weight-medium">
                {{
                  formatarData(
                    props.row.prazo_maximo ||
                      props.row.data_vencimento ||
                      props.row.dataVencimento
                  )
                }}
              </q-td>
            </template>

            <template v-slot:body-cell-diasVencimento="props">
              <q-td :props="props" class="text-center">
                <span class="text-red text-weight-bold">
                  {{
                    calcularDiasVencimento(
                      props.row.prazo_maximo ||
                        props.row.data_vencimento ||
                        props.row.dataVencimento
                    )
                  }}
                </span>
              </q-td>
            </template>
          </q-table>

          <div v-if="totalPages > 1" class="row justify-center q-mt-md">
            <div class="pagination-container">
              <q-btn
                flat
                dense
                size="sm"
                :disable="currentPage === 1"
                @click="currentPage--"
                class="pagination-arrow"
              >
                <q-icon name="chevron_left" size="16px" color="grey-6" />
              </q-btn>

              <template v-for="page in visiblePages" :key="page">
                <q-btn
                  v-if="page === '...'"
                  flat
                  dense
                  size="sm"
                  disable
                  class="pagination-dots"
                >
                  ...
                </q-btn>
                <q-btn
                  v-else
                  flat
                  dense
                  size="sm"
                  @click="currentPage = page"
                  class="pagination-number"
                  :class="{ 'pagination-active': currentPage === page }"
                >
                  {{ page }}
                </q-btn>
              </template>

              <q-btn
                flat
                dense
                size="sm"
                :disable="currentPage === totalPages"
                @click="currentPage++"
                class="pagination-arrow"
              >
                <q-icon name="chevron_right" size="16px" color="grey-6" />
              </q-btn>
            </div>
          </div>
        </div>

        <div
          v-if="hasCriticalItems"
          class="q-mt-md q-pa-md bg-red-1 rounded-borders"
        >
          <div class="row items-center">
            <q-icon name="error" color="red" size="md" class="q-mr-sm" />
            <div class="text-body2 text-red-8 text-weight-bold">
              ATENÇÃO: Este funcionário possui EPIs CRÍTICOS vencidos!
            </div>
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-pa-md bg-grey-1">
        <q-btn
          v-if="!isBlocked"
          label="Prosseguir mesmo assim"
          color="red"
          outline
          no-caps
          class="text-weight-bold"
          @click="$emit('confirm')"
          v-close-popup
        />
        <q-btn
          :label="isBlocked ? 'Entendi' : 'Cancelar'"
          :color="isBlocked ? 'primary' : 'grey'"
          :outline="!isBlocked"
          no-caps
          class="text-weight-bold"
          @click="$emit('cancel')"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";

export default {
  name: "StatusEpiModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    epiItems: {
      type: Array,
      default: () => [],
    },
    isBlocked: {
      type: Boolean,
      default: false,
    },
    hasCriticalItems: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(props, { emit }) {
    const show = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const currentPage = ref(1);
    const itemsPerPage = 5;

    const columns = [
      {
        name: "grupo",
        label: "Grupo de Produto",
        field: "grupo",
        align: "left",
        sortable: true,
        style: "width: 20%",
      },
      {
        name: "dataVencimento",
        label: "Data Maxima",
        field: "dataVencimento",
        align: "center",
        sortable: true,
        style: "width: 15%",
      },
      {
        name: "critico",
        label: "Tipo",
        field: "critico",
        align: "center",
        style: "width: 15%",
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "center",
        style: "width: 15%",
      },
    ];

    const formatarData = (data) => {
      if (!data) return "N/A";

      try {
        if (data.includes("/")) {
          return data;
        }

        if (data.includes("-")) {
          const [year, month, day] = data.split(" ")[0].split("-");
          return `${day}/${month}/${year}`;
        }

        return data;
      } catch (error) {
        console.error("Erro ao formatar data:", error);
        return "N/A";
      }
    };

    const calcularDiasVencimento = (data) => {
      if (!data) return "N/A";

      try {
        let dataVencimento;

        if (data.includes("/")) {
          const [day, month, year] = data.split("/");
          dataVencimento = new Date(year, month - 1, day);
        } else if (data.includes("-")) {
          const [year, month, day] = data.split(" ")[0].split("-");
          dataVencimento = new Date(year, month - 1, day);
        } else {
          return "N/A";
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        dataVencimento.setHours(0, 0, 0, 0);

        const diffTime = dataVencimento - hoje;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          return `${Math.abs(diffDays)} dias`;
        } else if (diffDays === 0) {
          return "Hoje";
        } else {
          return `+${diffDays} dias`;
        }
      } catch (error) {
        console.error("Erro ao calcular dias:", error);
        return "N/A";
      }
    };

    const paginatedItems = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      return props.epiItems.slice(start, end);
    });

    const totalPages = computed(() => {
      return Math.ceil(props.epiItems.length / itemsPerPage);
    });

    const visiblePages = computed(() => {
      const pages = [];
      const total = totalPages.value;
      const current = currentPage.value;

      if (total <= 5) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, "...", total);
        } else if (current >= total - 2) {
          pages.push(1, "...", total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, "...", current - 1, current, current + 1, "...", total);
        }
      }

      return pages;
    });

    return {
      show,
      columns,
      formatarData,
      calcularDiasVencimento,
      currentPage,
      paginatedItems,
      totalPages,
      visiblePages,
    };
  },
};
</script>

<style scoped>
.status-epi-modal {
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.status-troca-table {
  border: 2px solid #ffe0b2;
  border-radius: 8px;
  overflow: hidden;
}

.status-troca-table :deep(.q-table__top) {
  padding: 12px 16px;
  background-color: #fff3e0;
  border-bottom: 1px solid #ffe0b2;
}

.status-troca-table :deep(.q-table thead th) {
  background-color: #ffe0b2;
  font-weight: 700;
  color: #e65100;
  border-bottom: 2px solid #ffb74d;
  font-size: 13px;
  padding: 12px 8px;
}

.status-troca-table :deep(.q-table tbody td) {
  padding: 12px 8px;
  border-bottom: 1px solid #ffcc02;
  font-size: 12px;
}

.status-troca-table :deep(.q-table tbody tr:nth-child(even)) {
  background-color: #fff8e1;
}

.status-troca-table :deep(.q-table tbody tr:hover) {
  background-color: #fff3e0;
}

.status-troca-table :deep(.q-chip) {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.pagination-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
}

.pagination-arrow {
  min-width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 4px;
}

.pagination-arrow:hover:not([disabled]) {
  background-color: #f5f5f5;
}

.pagination-arrow[disabled] {
  opacity: 0.3;
}

.pagination-number {
  min-width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  transition: all 0.2s ease;
}

.pagination-number:hover:not(.pagination-active) {
  background-color: #f5f5f5;
  color: #333;
}

.pagination-active {
  background-color: #1976d2 !important;
  color: white !important;
}

.pagination-dots {
  min-width: 32px;
  height: 32px;
  padding: 0 !important;
  color: #999;
  font-weight: bold;
  pointer-events: none;
}

@media (max-width: 600px) {
  .status-epi-modal {
    min-width: 100vw !important;
    max-width: 100vw !important;
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
    margin: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .modal-title {
    font-size: 11px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
  }

  .modal-title .q-icon {
    font-size: 14px !important;
  }

  .modal-message {
    font-size: 10px !important;
    line-height: 1.3 !important;
    padding: 2px 0 !important;
    margin: 4px 0 !important;
    white-space: pre-wrap !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
  }

  .modal-content {
    padding: 4px 8px !important;
    flex: 1 !important;
    overflow-y: auto !important;
  }

  .modal-actions {
    padding: 8px !important;
    flex-direction: column-reverse !important;
    gap: 6px !important;
    background: #f5f5f5 !important;
    border-top: 1px solid #e0e0e0 !important;
  }

  .modal-actions .q-btn {
    width: 100% !important;
    min-height: 32px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
    padding: 4px 12px !important;
  }

  .status-troca-table {
    border: 1px solid #ffe0b2;
    font-size: 7px;
    margin: 4px 0;
  }

  .status-troca-table :deep(.q-table thead th) {
    font-size: 7px;
    padding: 2px 1px;
    line-height: 1.1;
  }

  .status-troca-table :deep(.q-table tbody td) {
    font-size: 6px;
    padding: 2px 1px;
    line-height: 1.1;
  }

  .status-troca-table :deep(.q-chip) {
    font-size: 5px;
    min-height: 12px;
    padding: 1px 2px;
  }

  .pagination-container {
    gap: 1px;
    padding: 2px 0;
    justify-content: center;
    flex-wrap: wrap;
  }

  .pagination-arrow,
  .pagination-number,
  .pagination-dots {
    min-width: 20px;
    height: 20px;
    font-size: 8px;
  }

  .text-subtitle1 {
    font-size: 10px !important;
    margin-bottom: 2px !important;
    line-height: 1.2 !important;
  }

  .text-body2 {
    font-size: 8px !important;
    line-height: 1.2 !important;
  }

  .status-epi-modal :deep(.q-card-section) {
    padding: 4px 8px !important;
  }

  .status-epi-modal .bg-red-1 {
    padding: 3px 4px !important;
    margin: 2px 0 !important;
  }

  .status-epi-modal .bg-red-1 .q-icon {
    font-size: 12px !important;
  }

  .modal-header {
    padding: 4px 8px !important;
  }
}

@media (max-width: 480px) {
  .modal-title {
    font-size: 10px !important;
    line-height: 1.1 !important;
  }

  .modal-title .q-icon {
    font-size: 12px !important;
  }

  .modal-message {
    font-size: 9px !important;
    line-height: 1.2 !important;
    margin: 3px 0 !important;
  }

  .modal-content {
    padding: 3px 6px !important;
  }

  .modal-actions {
    padding: 6px !important;
    gap: 4px !important;
  }

  .modal-actions .q-btn {
    min-height: 28px !important;
    font-size: 10px !important;
    padding: 3px 8px !important;
  }

  .status-troca-table :deep(.q-table thead th) {
    font-size: 6px;
    padding: 1px;
  }

  .status-troca-table :deep(.q-table tbody td) {
    font-size: 5px;
    padding: 1px;
  }

  .status-troca-table :deep(.q-chip) {
    font-size: 4px;
    min-height: 10px;
    padding: 0px 1px;
  }

  .text-subtitle1 {
    font-size: 9px !important;
  }

  .text-body2 {
    font-size: 7px !important;
  }

  .status-epi-modal :deep(.q-card-section) {
    padding: 3px 6px !important;
  }

  .modal-header {
    padding: 3px 6px !important;
  }
}

.mobile-modal {
  height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.mobile-modal .modal-header {
  flex-shrink: 0 !important;
  padding: 4px 8px !important;
}

.mobile-modal .modal-content {
  flex: 1 !important;
  overflow-y: auto !important;
  padding: 4px 8px !important;
  min-height: 0 !important;
}

.mobile-modal .modal-actions {
  flex-shrink: 0 !important;
  position: sticky !important;
  bottom: 0 !important;
  background: #f5f5f5 !important;
  border-top: 1px solid #e0e0e0 !important;
  padding: 8px !important;
  z-index: 1000 !important;
  display: flex !important;
  flex-direction: column-reverse !important;
  gap: 6px !important;
}

.mobile-modal .action-btn {
  width: 100% !important;
  min-height: 32px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  border-radius: 4px !important;
  padding: 6px 12px !important;
}

@media (max-width: 600px) {
  .q-dialog__inner--maximized .q-dialog__inner {
    padding: 0 !important;
  }

  .q-dialog__inner--maximized .status-epi-modal {
    height: 100vh !important;
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 100vw !important;
    border-radius: 0 !important;
    margin: 0 !important;
  }

  .status-epi-modal {
    display: flex !important;
    flex-direction: column !important;
    height: 100vh !important;
  }

  .modal-header {
    flex-shrink: 0 !important;
    order: 1 !important;
  }

  .modal-content {
    flex: 1 !important;
    order: 2 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
  }

  .modal-actions {
    flex-shrink: 0 !important;
    order: 3 !important;
    position: sticky !important;
    bottom: 0 !important;
    background: #f5f5f5 !important;
    border-top: 1px solid #e0e0e0 !important;
    margin-top: auto !important;
    z-index: 1000 !important;
  }
}
</style>
